import { UserManager, WebStorageStateStore, type User } from 'oidc-client-ts';
import { getConfig } from '../config.js';

let manager: UserManager | null = null;
let currentUser: User | null = null;

/** The OIDC UserManager for Cognito, or null in fixture mode (no cognito config). */
export function userManager(): UserManager | null {
  const cognito = getConfig().cognito;
  if (!cognito) return null;
  if (!manager) {
    manager = new UserManager({
      authority: cognito.authority,
      client_id: cognito.clientId,
      redirect_uri: cognito.redirectUri,
      post_logout_redirect_uri: cognito.redirectUri,
      response_type: 'code',
      scope: cognito.scope,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      extraQueryParams: cognito.identityProvider ? { identity_provider: cognito.identityProvider } : {},
    });
  }
  return manager;
}

export function setUser(user: User | null): void {
  currentUser = user;
}

/** The Cognito ID token (carries the `tier` claim) sent as the API Bearer token. */
export function getIdToken(): string | undefined {
  return currentUser?.id_token;
}

export function isAuthenticated(): boolean {
  return Boolean(currentUser && !currentUser.expired);
}
